<template>
  <b-card-group columns>
    <b-card no-body class="panel">
      <div slot="header">Czas pracy</div>
      <b-list-group flush class="list">
        <b-list-group-item v-if="$is('admin', 'hr')" :to="{ name: 'holidays' }">Dni wolne od pracy</b-list-group-item>
        <b-list-group-item v-if="$is('admin', 'hr')" :to="{ name: 'absence' }">Rodzaje nieobecności</b-list-group-item>
        <b-list-group-item v-if="$is('admin', 'hr')" :to="{ name: 'timetable' }">Harmonogramy pracy</b-list-group-item>
      </b-list-group>
    </b-card>
    <b-card no-body class="panel">
      <div slot="header">Wyposażenie</div>
      <b-list-group flush class="list">
        <b-list-group-item v-if="$is('admin', 'equipment')" :to="{ name: 'eqtypes' }">Typy wyposażenia</b-list-group-item>
      </b-list-group>
    </b-card>
    <b-card no-body class="panel">
      <div slot="header">Ustawienia</div>
      <b-list-group flush class="list">
        <b-list-group-item v-if="$is('admin', 'manager', 'hr')" :to="{ name: 'employees' }">Pracownicy</b-list-group-item>
        <b-list-group-item v-if="$isAdmin()" :to="{ name: 'logicalStructure' }">Struktura</b-list-group-item>
        <b-list-group-item v-if="$is('admin', 'manager')" :to="{ name: 'companies' }">Firmy</b-list-group-item>
      </b-list-group>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
.panel {
  margin-top: 0.5em;
}
.list {
  font-size: 0.9em;
}
</style>
